import { defineStore } from 'pinia';
import axios from 'axios';
import {getAPIURL} from '../logic/api';

const initialState = {
  profiles: [],
  currentProfile: null,
  isEditing: false
};

export const useProfileStore = defineStore('profile', {
  state: () => ({ ...initialState }),

  getters: {
    getCurrentProfile: (state) => state.currentProfile,
    getIsEditing: (state) => state.isEditing,
    getAllProfiles: (state) => state.profiles
  },

  actions: {
    async fetchProfiles() {
      try {
        const token = localStorage.getItem('token');
        
        const config = token ? {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        } : {};
        
        const response = await axios.get(getAPIURL()+'/api/profile/get-all-profiles', config);
        this.profiles = response.data;
      } catch (error) {
        console.error('Error fetching profiles:', error);
        throw error;
      }
    },

    async addProfile(profileData) {
      try {
        await axios.post(getAPIURL()+'/api/profile/add-new-profile', profileData);
        await this.fetchProfiles();
      } catch (error) {
        console.error('Error adding profile:', error);
        throw error;
      }
    },

    async updateProfile(profileData) {
      try {
        await axios.put(getAPIURL()+'/api/profile/update-profile', profileData);
        await this.fetchProfiles();
      } catch (error) {
        console.error('Error updating profile:', error);
        throw error;
      }
    },

    async deleteProfile(profileID) {
      try {
        await axios.delete(`https://budgeteer.x01r.xyz/api/profile/remove-profile?profileID=${profileID}`);
        await this.fetchProfiles();
      } catch (error) {
        console.error('Error deleting profile:', error);
        throw error;
      }
    },

    setCurrentProfile(profile) {
      this.currentProfile = profile;
    },

    resetCurrentProfile() {
      Object.assign(this, initialState);
    }
  }
}); 